const elements = [
    'AD', //Andorra
    'AE', //De Forenede Arabiske Emirater
    'AF', //Afghanistan
    'AG', //Antigua og Barbuda
    'AI', //Anguilla
    'AL', //Albanien
    'AM', //Armenien
    'AO', //Angola
    'AQ', //Antarktis
    'AR', //Argentina
    'AS', //Amerikansk Samoa
    'AT', //Østrig
    'AU', //Australien
    'AW', //Aruba
    'AZ', //Aserbajdsjan
    'BA', //Bosnien-Hercegovina
    'BB', //Barbados
    'BD', //Bangladesh
    'BE', //Belgien
    'BF', //Bourkina Faso
    'BG', //Bulgarien
    'BH', //Bahrain
    'BI', //Burundi
    'BJ', //Benin
    'BL', //Saint Barthelmy
    'BM', //Bermudaøerne
    'BN', //Brunei
    'BO', //Bolivia
    'BQ', //Bonaire, Saint Eusttius og Saba
    'BR', //Brasilien
    'BS', //Bahamaøerne
    'BT', //Bhutan
    'BV', //Bouvetøen
    'BW', //Botswana
    'BY', //Hviderusland
    'BZ', //Belize
    'CA', //Canada
    'CC', //Cocosøerne (eller Keelingøerne)
    'CD', //Den Demokratiske Republik Congo
    'CF', //Den Centralafrikanske Republik
    'CG', //Congo
    'CH', //Schweiz
    'CI', //Elfenbenskysten
    'CK', //Cookøerne
    'CL', //Chile
    'CM', //Cameroun
    'CN', //Kina
    'CO', //Colombia
    'CR', //Costa Rica
    'CS', //Serbien og Montenegro
    'CU', //Cuba
    'CV', //Cap Verde
    'CW', //Curacao
    'CX', //Juleøen
    'CY', //Cypern
    'CZ', //Tjekkiet
    'DE', //Tyskland
    'DJ', //Djibouti
    'DK', //Danmark
    'DM', //Dominica
    'DO', //Den Dominikanske Republik
    'DZ', //Algeriet
    'EC', //Ecuador
    'EE', //Estland
    'EG', //Egypten
    'EH', //Vestsahara
    'ER', //Eritrea
    'ES', //Spanien (undtagen XC, XL)
    'ET', //Etiopien
    'EU', //EU
    'FI', //Finland
    'FJ', //Fiji
    'FK', //Falklandsøerne
    'FM', //Mikronesiens Forenede Stater
    'FO', //Færøerne
    'FR', //Frankrig
    'FS', //Fastlandssoklen
    'GA', //Gabon
    'GB', //Det Forenede Kongerige
    'GD', //Grenada
    'GE', //Georgien
    'GH', //Ghana
    'GI', //Gibraltar
    'GL', //Grønland
    'GM', //Gambia
    'GN', //Guinea
    'GQ', //Ækvatorialguinea
    'GR', //Grækenland
    'GS', //South Georgia og De Sydlige Sandwichøer
    'GT', //Guatemala
    'GU', //Guam
    'GW', //Guinea-Bissau
    'GY', //Guyana
    'HK', //Hongkong
    'HM', //Heardøen og McDonaldøerne
    'HN', //Honduras
    'HR', //Kroatien
    'HT', //Haiti
    'HU', //Ungarn
    'ID', //Indonesien
    'IE', //Irland
    'IL', //Israel
    'IN', //Indien
    'IO', //Britiske områder i Det indiske Ocean
    'IQ', //Irak
    'IR', //Iran
    'IS', //Island
    'IT', //Italien
    'JM', //Jamaica
    'JO', //Jordan
    'JP', //Japan
    'KE', //Kenya
    'KG', //Kirgistan
    'KH', //Cambodja (Kampuchea)
    'KI', //Kiribati
    'KM', //Comorerne (undtagen Mayotte)
    'KN', //St. Kitts og Nevis
    'KP', //Nordkorea
    'KR', //Sydkorea
    'KW', //Kuwait
    'KY', //Caymanøerne
    'KZ', //Kasakhstan
    'LA', //Laos
    'LB', //Libanon
    'LC', //St. Lucia
    'LI', //Liechtenstein
    'LK', //Sri Lanka
    'LR', //Liberia
    'LS', //Lesotho
    'LT', //Litauen
    'LU', //Luxembourg
    'LV', //Letland
    'LY', //Libyen
    'MA', //Marokko
    'MD', //Moldova
    'ME', //Montenegro
    'MG', //Madagaskar
    'MH', //Marshalløerne
    'MK', //Den Tidligere Jugoslaviske Republik
    'ML', //Mali
    'MM', //Myanmar
    'MN', //Mongoliet
    'MO', //Macao
    'MP', //Nordmarianerne
    'MR', //Mauretanien
    'MS', //Montserrat
    'MT', //Malta
    'MU', //Mauritius
    'MV', //Maldiverne
    'MW', //Malawi
    'MX', //Mexico
    'MY', //Malaysia
    'MZ', //Mozambique
    'NA', //Namibia
    'NC', //Ny Caledonien 
    'NE', //Niger
    'NF', //Norfolk Island
    'NG', //Nigeria
    'NI', //Nicaragua
    'NL', //Nederlandene
    'NO', //Norge
    'NP', //Nepal
    'NR', //Nauru
    'NU', //Niue
    'NZ', //New Zealand
    'OM', //Oman
    'PA', //Panama
    'PE', //Peru
    'PF', //Fransk Poynesien
    'PG', //Papua-Ny Guinea
    'PH', //Filippinerne
    'PK', //Pakistan
    'PL', //Polen
    'PM', //St Pierre og Miquelon
    'PN', //Pitcairnøerne
    'PS', //Det besatte palæstinensiske område
    'PT', //Portugal
    'PW', //Palau
    'PY', //Paraguay
    'QA', //Qatar
    'QP', //Åbent hav
    'QQ', //Proviantering og bunkring
    'QR', //Proviantering og bunkring i handelen mellem EU`s medlemsstater
    'QS', //Proviantering og bunkring i handelen med tredjelande
    'QU', //Lande og territorier, som ikke er nærmere præciseret
    'QV', //Lande og territorier, som ikke er nærmere præciseret i handelen mellem EU`s medlemsstater
    'QW', //Lande og territorier, som ikke er nærmere præciseret i handelen med tredjelande
    'QX', //Lande og territorier, som af handelsmæssige eller militære grunde ikke er nærmere præciseret
    'QY', //Lande og territorier, som af handelsmæssige eller militære grunde ikke er nærmere præciseret i handelen mellem EU`s medlemsstater
    'QZ', //Lande og territorier, som af handelsmæssige eller militære grunde ikke er nærmere præciseret i handelen med tredjelande
    'RO', //Rumænien
    'RU', //Den Russiske Føderation
    'RW', //Rwanda
    'SA', //Saudi Arabien
    'SB', //Salomon-øerne
    'SC', //Seychellerne og tilhør.områder
    'SD', //Sudan
    'SE', //Sverige
    'SG', //Singapore
    'SH', //St Helena og tilhør.områder
    'SI', //Slovenien
    'SJ', //Svalbard
    'SK', //Slovakiet
    'SL', //Sierra Leone
    'SM', //San Marino
    'SN', //Senegal
    'SO', //Somalia
    'SR', //Suriname
    'SS', //Sydsudan
    'ST', //Sao Tomé og Príncipe
    'SV', //El Salvador
    'SY', //Syrien
    'SZ', //Swaziland
    'SX', //Saint-Maarten (den hollandske del)
    'TC', //Turks- og Caicosøerne
    'TD', //Tchad
    'TF', //De franske besiddelser i det sydlige Indiske Ocean
    'TG', //Togo
    'TH', //Thailand
    'TJ', //Tadsjikistan
    'TK', //Tokelau
    'TL', //Østtimor
    'TM', //Turkmenistan
    'TN', //Tunesien
    'TO', //Tonga
    'TR', //Tyrkiet
    'TT', //Trinidad og Tobago
    'TV', //Tuvalu
    'TW', //Taiwan
    'TZ', //Tanzania
    'UA', //Ukraine
    'UG', //Uganda
    'UK', //Storbritanien
    'UM', //USA´s mindre øbesiddelser
    'US', //Amerikas Forenede Stater
    'UY', //Uruguay
    'UZ', //Usbekistan
    'VA', //Vatikanstaten
    'VC', //St Vincent
    'VE', //Venezuela
    'VG', //De Britiske Jomfruøer
    'VI', //De Amerikanske Jomfruøer
    'VN', //Vietnam
    'VU', //Vanuatu
    'WF', //Wallis og Futuna
    'WS', //Samoa
    'XA', //Am. Oceanien
    'XC', //Ceuta
    'XK', //Kosovo
    'XL', //Melilla
    'XO', //Australsk Oceanien
    'XP', //Vestbredden/Gazastriben
    'XR', //Polarområder
    'XS', //Serbien
    'YE', //Yemen
    'YU', //Jugoslavien
    'ZA', //Sydafrika
    'ZM', //Zambia
    'ZW', //Zimbabwe
]

export const countries = {
    elements,
}